import React from 'react';
import FilterTagsMobile from 'src/components/college-search/filter-tags/filter-tags-mobile';
import AdmissionFilters from 'src/components/college-search/filters/admission-filters';
import AttributeFilters from 'src/components/college-search/filters/attribute-filters';
import CostFilters from 'src/components/college-search/filters/cost-filters';
import DiversityFilters from 'src/components/college-search/filters/diversity-filters';
import GraduationFilters from 'src/components/college-search/filters/graduation-filters';
import LocationFilters from 'src/components/college-search/filters/location-filters';
import MajorsFilters from 'src/components/college-search/filters/majors-filters';
import NcaaFilters from 'src/components/college-search/filters/ncaa-filters';
import SizeFilters from 'src/components/college-search/filters/size-filters';
import TagsFilters from 'src/components/college-search/filters/tags-filters';
import TypeFilters from 'src/components/college-search/filters/type-filters';
import CollegeNameFilter from 'src/components/college-search/filters/college-name-filter';
import useUserType from 'src/hooks/use-user-type/use-user-type';
import {useMediaQuery} from 'src/hooks/use-media-query';

interface Props {
  getColleges: () => void;
}

const Filters = ({getColleges}: Props) => {
  const {isTransfer} = useUserType();

  const mq = useMediaQuery();

  return (
    <div className="college-search-filters-sidebar" role="group" aria-label="Filter Colleges">
      {mq.MS_AND_DOWN && <FilterTagsMobile />}
      <CollegeNameFilter getColleges={getColleges} />
      <LocationFilters />
      <AttributeFilters getColleges={getColleges} />
      <MajorsFilters getColleges={getColleges} />
      <TypeFilters getColleges={getColleges} />
      <CostFilters getColleges={getColleges} />
      {!isTransfer && <AdmissionFilters getColleges={getColleges} />}
      <SizeFilters getColleges={getColleges} />
      <NcaaFilters getColleges={getColleges} />
      <DiversityFilters getColleges={getColleges} />
      <GraduationFilters getColleges={getColleges} />
      <TagsFilters getColleges={getColleges} />
    </div>
  );
};

export default Filters;
